export default __webpack_public_path__ + "static/media/Golos Text_Black.ac573a4a.ttf";